import { memo } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useGatewayChannel } from '@renderer/hooks/useGatewayChannel'
import { REMINDERS_QUERY_KEY, isRecentReminderLocalMutation } from '@renderer/overlay/Sidepanel/hooks/use-reminders'

/**
 * Provider that subscribes to the reminders gateway channel for real-time updates.
 * Invalidates the React Query cache on any created/updated/deleted event,
 * unless a local mutation just happened (to avoid clobbering optimistic UI).
 */
export const RemindersGatewayProvider = memo(({ children }: React.PropsWithChildren) => {
  const queryClient = useQueryClient()

  useGatewayChannel('reminders', () => {
    if (isRecentReminderLocalMutation()) return
    queryClient.invalidateQueries({ queryKey: [REMINDERS_QUERY_KEY] })
  })

  return <>{children}</>
})
RemindersGatewayProvider.displayName = 'RemindersGatewayProvider'
